import { RequestHeaders } from './RequestHeaders';
import { RequestStrategy } from './Strategy';

export class PublicStrategy extends RequestStrategy {
  public getRequestHeaders(): RequestHeaders {
    return this.buildHeaders();
  }
}
